'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = require('react');
var React__default = _interopDefault(React);
var classnames = _interopDefault(require('classnames'));
var PropTypes = _interopDefault(require('prop-types'));
var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));
var _classCallCheck = _interopDefault(require('@babel/runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('@babel/runtime/helpers/createClass'));
var _assertThisInitialized = _interopDefault(require('@babel/runtime/helpers/assertThisInitialized'));
var _inherits = _interopDefault(require('@babel/runtime/helpers/inherits'));
var _possibleConstructorReturn = _interopDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));
var _getPrototypeOf = _interopDefault(require('@babel/runtime/helpers/getPrototypeOf'));
var shortid = _interopDefault(require('shortid'));
var generateDimension = require('../../util/generateDimension.js');

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
/**
 * ToggleContent
 *
 * @visibleName
 * @see Added: v5.8.0, Last updated: v6.3.0
 */

var ToggleContent = /*#__PURE__*/function (_React$Component) {
  _inherits(ToggleContent, _React$Component);

  var _super = _createSuper(ToggleContent);

  function ToggleContent(props) {
    var _this;

    _classCallCheck(this, ToggleContent);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.state.show) {
        _this.setState({
          height: 'auto',
          overflow: 'visible'
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "afterOpen", function () {
      setTimeout(function () {
        _this.setState({
          height: 'auto',
          overflow: 'visible'
        });
      }, _this.delayAnimation);
    });

    _defineProperty(_assertThisInitialized(_this), "afterClose", function () {
      setTimeout(function () {
        _this.setState({
          overflow: 'hidden',
          height: '0px'
        });
      }, _this.delayAnimation);
    });

    _defineProperty(_assertThisInitialized(_this), "afterToggle", function () {
      if (_this.state.show) {
        _this.afterOpen();
      } else {
        _this.afterClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      _this.setState(function (prevState) {
        return {
          show: !prevState.show
        };
      }); // Set height of container when opening or closing
      // Overflow will handle the animation


      if (!_this.props.disableAnimation) {
        _this.setState({
          height: _this.getContentHeight()
        }, _this.afterToggle);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setContentRef", function (element) {
      _this.contentRef = element;
    });

    _defineProperty(_assertThisInitialized(_this), "getContentHeight", function () {
      return generateDimension.default.getReactElementPosition(_this.contentRef).height;
    });

    _this.contentRef = null;
    _this.state = {
      contentId: shortid.generate(),
      show: props.visible,
      height: '0px',
      overflow: 'hidden'
    }; // Delay is set to the animationDuration in milliseconds
    // Set the height to auto or 0px after delay
    // Set the overflow to visible or hidden after delay

    _this.delayAnimation = _this.props.animationDuration * 1000;
    return _this;
  }

  _createClass(ToggleContent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!this.props.disableAnimation && !this.state.show && prevState.height === 'auto') {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          height: this.getContentHeight()
        }, this.afterClose);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          renderContent = _this$props.renderContent,
          disableAnimation = _this$props.disableAnimation,
          animationDuration = _this$props.animationDuration,
          _this$props$id = _this$props.id,
          id = _this$props$id === void 0 ? this.state.contentId : _this$props$id;
      var _this$state = this.state,
          show = _this$state.show,
          height = _this$state.height,
          overflow = _this$state.overflow;
      var buttonProps = {
        'aria-controls': id,
        'aria-expanded': show
      };
      var contentProps = {
        id: id
      };
      var yesAnimation = /*#__PURE__*/React__default.createElement("div", {
        className: "toggle-content__body",
        style: {
          height: height,
          overflow: overflow,
          transition: "height ".concat(animationDuration, "s ease-out")
        }
      }, /*#__PURE__*/React__default.createElement("div", _extends({
        ref: this.setContentRef
      }, contentProps), children, /*#__PURE__*/React__default.createElement("div", {
        style: {
          height: '1px',
          marginTop: '-1px'
        }
      })));
      var noAnimation = /*#__PURE__*/React__default.createElement("div", _extends({
        className: "toggle-content__body",
        ref: this.setContentRef
      }, contentProps), /*#__PURE__*/React__default.createElement("div", null, show && children));
      return /*#__PURE__*/React__default.createElement("div", {
        className: classnames('toggle-content', className, {
          'toggle-content--open': show,
          'toggle-content--closed': !show
        })
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "toggle-content__header"
      }, renderContent({
        show: show,
        toggle: this.toggle,
        buttonProps: buttonProps
      })), disableAnimation ? noAnimation : yesAnimation);
    }
  }]);

  return ToggleContent;
}(React__default.Component);

process.env.NODE_ENV !== "production" ? ToggleContent.propTypes = {
  /**
   * Nodes that will be shown/hidden
   * @since v5.8.0
   */
  children: PropTypes.node.isRequired,

  /**
   * Additional classname added to the parent div
   * @since v5.8.0
   */
  className: PropTypes.string,

  /**
   * Setting the visible prop to true, will show the children nodes on render
   * @since v5.8.0
   */
  visible: PropTypes.bool,

  /**
   * Render props function called with
   *
   * - `show`: bool state toggled when firing the toggle method. Can be used to make conditional changes to the DOM
   *
   * - `toggle`: method called, toggles the `show` state. Can be used on a callback function
   *
   * - `buttonProps`: object containing aria attributes that should be spread onto the button element being used.
   *
   * @since v5.8.0, Updated: v6.3.0
   */
  renderContent: PropTypes.func.isRequired,

  /**
   * Children will be toggled without animation and conditional displayed
   * @since v5.8.0
   */
  disableAnimation: PropTypes.bool,

  /**
   * If disableAnimation is false, animationDuration is the time in seconds it takes to complete the animation
   * @since v5.8.0
   */
  animationDuration: PropTypes.number,

  /**
   * Override the generated id for the button/content control
   * @since v6.3.0
   */
  id: PropTypes.string
} : void 0;
ToggleContent.defaultProps = {
  className: undefined,
  visible: false,
  disableAnimation: false,
  animationDuration: 0.15,
  id: undefined
};

exports.default = ToggleContent;
